export default class VideoController {
  constructor() {
    this.observer = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.loadVideo(entry.target);

          // only play if the video is actually paused
          if (entry.target.paused) {
            await this.playVideo(entry.target);
          }
        } else {
          // only pause if the video is actually playing
          if (!entry.target.paused) {
            entry.target.pause();
          }
        }
      }
    }, {});

    // initialize playback on load
    document.addEventListener("turbo:load", (evt) =>
      this.initializePlayback(evt),
    );
    document.addEventListener("algolia-search", (evt) =>
      this.initializePlayback(evt),
    );

    // stop the videos when navigating away
    document.addEventListener("turbo:before-cache", (evt) =>
      this.stopVideos(evt),
    );

    // stop the videos when the tab is not visible
    document.addEventListener("visibilitychange", (evt) =>
      this.onVisibilityChange(evt),
    );
  }

  onVisibilityChange() {
    const videos = document.querySelectorAll("video");
    for (const video of videos) {
      if (document.hidden) {
        if (!video.paused) {
          video.pause();
        }
        this.observer.unobserve(video);
      } else {
        this.observer.observe(video);
      }
    }
  }

  loadVideo(video) {
    // check if the video is already loaded
    if (video.classList.contains("loaded")) return;

    for (var source in video.children) {
      var videoSource = video.children[source];
      if (
        typeof videoSource.tagName === "string" &&
        videoSource.tagName === "SOURCE"
      ) {
        videoSource.src = videoSource.dataset.src;
        video.load();
        video.classList.add("loaded");
      }
    }
  }

  async playVideo(video) {
    try {
      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        await video.play();
      } else {
        // if video doesn't have enough data yet, wait for it to be ready
        video.addEventListener(
          "canplay",
          async () => {
            try {
              await video.play();
            } catch (error) {
              console.error("Error playing video after canplay event:", error);
            }
          },
          { once: true },
        );
      }
    } catch (error) {
      console.error("Error playing video:", error);
    }
  }

  initializePlayback() {
    const videos = document.querySelectorAll("video");

    for (const video of videos) this.observer.observe(video);
  }

  stopVideos() {
    const videos = document.querySelectorAll("video");
    for (const video of videos) {
      if (!video.paused) {
        video.pause();
      }
      this.observer.unobserve(video);
    }
  }
}
